import { render, staticRenderFns } from "./FileCollabs.vue?vue&type=template&id=5cd96622"
import script from "./FileCollabs.vue?vue&type=script&lang=js"
export * from "./FileCollabs.vue?vue&type=script&lang=js"
import style0 from "./FileCollabs.vue?vue&type=style&index=0&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports